import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  load=false
  appointments
  doctorInfo

  constructor(private http: HttpClient) { }


  loadAppointments(type, startDate, endDate, UID, code) {
    if (!type || !startDate) return;
  
    let params = {
      'UID': UID,
      "start": startDate,
      "end": endDate
    };
  
    if (code) {
      params['code'] = code;
    }
  
   
    this.http.get('/api/appointment/appointmentsForPrint', { params: params }).subscribe((data) => {
       this.appointments = data['appointments'];
       this.doctorInfo=data['doctorInfo']
      this.load = true;
    });
  }
  
}
